<template>
	<vue-draggable-resizable :x="itemMdata.parentStyle.left" :draggable="isDraggable" :y="itemMdata.parentStyle.top" :z="itemMdata.parentStyle.zIndex" :minw="1" :minh="1" :w="itemMdata.parentStyle.width" :h="itemMdata.parentStyle.height" :active.sync="itemMdata.parentStyle.active" v-on:dragging="onDrag" :parent="itemMdata.parent" v-on:resizing="onResize" v-on:activated="activated">
		<div :id="itemMdata.allId" :class="['hove_con',itemMdata.emitStr,'m_'+itemMdata.tName,{hover:itemMdata.parentStyle.active}]">
			<p class="edit_con" style="z-index:100;">
				<span class="" v-if="itemMdata.tName=='mFont'" @click="manageMfont(itemMdata)">编辑文本</span>
				<span class="icon edit_mode" @click="manageMode(itemMdata)"><i>管理{{itemMdata.tText}}</i></span>
				<span class="icon animation" @click="funcEmition(itemMdata)"><i>设置动画</i></span>
				<span class="icon style" v-if="itemMdata.tName=='moduleAreaNav'" @click="editDial.isStyleEdit = true"><i>设置导航</i></span>
				<span class="icon style" v-if="itemMdata.tName=='msgSubmit'||itemMdata.tName=='siteForm'" @click="editDial.isStyleEdit = true"><i>编辑按钮</i></span>
				<span @click="removeComponent(itemMdata)" class="icon delete"><i>删除模块</i></span>
			</p>
			<div :itemMdata="itemMdata" ref="child" @isFuncur="isFuncur" :is="itemMdata.tName"></div>
			<moduleAreaNavStyle v-if="editDial.isStyleEdit" :itemMdata='itemMdata' :editDial="editDial"></moduleAreaNavStyle>
		</div>
	</vue-draggable-resizable>
</template>
<script>
	let ov = {};
	import VueDraggableResizable from 'vue-draggable-resizable'
	import moduleAreaNavStyle from './m/moduleAreaNavStyle.vue'
	import bus from '@/common/bus.js'
	import api from '@/api/$ajax.js'
	ov['moduleAreaNavStyle'] = moduleAreaNavStyle;
	ov['VueDraggableResizable'] = VueDraggableResizable;
	let mName = ['mFont', 'mImage', 'mButton', 'graphic', 'mNewDes', 'columnPicture', 'mCaseDes', 'mPhotoDes', 'multiCarousel', 'circleRrea', 'articleScrap', 'productNav', 'newlyShop', 'productShow', 'productDes', 'productSearch', 'photoMoreCard', 'areaFile', 'areaMap', 'areaIndexFavorite', 'areaLocation', 'areaMap', 'sidebar', 'moduleAreaNav', 'footerNav', 'memberLogin', 'msgSubmit', 'siteForm', 'serviceOnline', 'siteQrCode', 'zhaopin', 'videoNav', 'areaFileNav', 'zhaopinDetail', 'mltilingual', 'areaCode', 'sitemap', 'singlePage', 'areaDate', 'areaFlv', 'friendLink', 'searchResults'];

	for(let m = 0; mName.length > m; m++) {
		ov[mName[m]] = () =>
			import('./m/' + mName[m] + '.vue')
	}

	export default {
		name: 'mConet',
		props: ['itemMdata', "itemInner"],
		components: ov,
		created() {
     
			let ts = this;
			ts.itemMdata.allId = ts.itemMdata.allId || "m" + ts.$utils.GenNonDuplicateID();
			ts.itemMdata.parentStyle = ts.itemMdata.parentStyle || {};
			ts.itemMdata.parentStyle.zIndex = ts.itemMdata.parentStyle.zIndex < 1 ? 1 : ts.itemMdata.parentStyle.zIndex;
			ts.itemMdata.parentStyle.width = ts.itemMdata.parentStyle.width || 1;
			ts.itemMdata.parentStyle.height = ts.itemMdata.parentStyle.height || 1;

			bus.$on('isfontFocus' + ts.itemMdata.allId, (data) => {
				ts.isDraggable = data;
			});

			ts.itemMdata.isStyleEdit = false;
			ts.itemMdata.emitStr = ts.itemMdata.emitStr || "";
		},
		methods: {
			manageMode(i) { //弹窗模块编辑
				let ts = this;
				ts.$refs.child.isFuncur(ts.itemMdata, 1);
			},
			showMenu(index) { //右键弹窗显示
				event.preventDefault();
				event.stopPropagation();
				var x = event.clientX;
				var y = event.clientY;
				this.contextMenuData.axios = {
					x,
					y
				}
			},
			isFuncur(i, editDial, flag) { //激活弹窗模块编辑
				let ts = this;
				if(flag == 2) {
					ts.editCodeFun(i, editDial);
				} else {
					editDial.content = "";
					ts.$emit('isFuncur', i, editDial);
				}

			},
			manageMfont() { //编辑文本模块
				//console.log(item);
				this.$refs.child.editorFun();
			},
			funcEmition(item) { //设置模块动画
				console.log(item);
				bus.$emit('onSetAmit', item);
			},
			managecode(i) { //管理模块代码
				let ts = this;
				ts.$refs.child.isFuncur(ts.itemMdata, 2);
			},
			editCodeFun(i, editDial) { //编辑代码后的回调
				let ts = this;
				let obj = {
					tName: i.tName,
					type: ts.param.type
				};
				if(i.editorId) {
					obj = {
						id: i.editorId
					};
				}
				api.get('https://bjq.aititiapi.top/api/modular/des', false, obj, function(data) {
					editDial.isEdit = true;
					editDial.content = Base64.decode(data.data.content);
					ts.$emit('isFuncur', i, editDial);
				});
			},
			onDrag: function(x, y) {
				let ts = this;
				ts.itemMdata.parentStyle.left = x;
				ts.itemMdata.parentStyle.top = y;
			},
			activated: function(x, y, width, height) {
				let ts = this;
				console.log("activated")
			},
			onResize: function(x, y, width, height) {
				let ts = this;
				let itemMdata = ts.itemMdata;

				itemMdata.parentStyle.left = x;
				itemMdata.parentStyle.top = y;

				width = width < 1 ? 1 : width;
				height = height < 1 ? 1 : height;
				itemMdata.parentStyle.width = width;
				itemMdata.parentStyle.height = height;
				if(ts.$refs.child && ts.$refs.child.resizefun) {
					ts.$refs.child.resizefun(width + 'px', height + 'px');
				}

			},
			removeComponent(i) { //删除模块
				let ts = this;
				ts.$emit('removeComponent', i);
				ts.$emit('recomponent', i);
			}
		},
		mounted() {
			let ts = this;
			if(ts.itemMdata.emitStr) {
				setTimeout(function(){
					dzit.initScroll(ts.itemMdata.allId, ts.itemMdata.emitStr);
				},400);
			}
		},
		data() {
			return {
				title: "模块容器",
				editDial: {
					editDialWidth: "700px",
					editDialHeight: "580px",
					isEdit: true,
					isStyleEdit: false,
					title: '管理' + this.itemMdata.tText,
				},
				isDraggable: true,
				param: {
					id: this.$route.params.id,
					param: this.$route.params.param,
					company_id: this.$route.query.company_id,
					token: this.$route.query.token,
					type: this.$route.query.type,
					lang: this.$route.query.lang,
					domain_url: this.$route.query.domain_url,
					mobile_version_id: this.$route.query.mobile_version_id,
					pc_version_id: this.$route.query.pc_version_id
				},
				contextMenuData: {
					// the contextmenu name(@1.4.1 updated)
					menuName: this.$utils.guid(),
					axios: {
						x: null,
						y: null
					},
					//Menu options (菜单选项)
					menulists: [{
							fnHandler: 'upFloor', // Binding events(绑定事件)
							btnName: '置于顶层' // The name of the menu option (菜单名称)
						},
						{
							fnHandler: 'moveUpFloor',
							btnName: '上移一层'
						},
						{
							fnHandler: 'moveDownFloor',
							btnName: '下移一层'
						},
						{
							fnHandler: 'copyItem',
							btnName: '复制模块'
						},
						{
							fnHandler: 'downFloor',
							btnName: '置于底层'
						}
					]
				}

			}
		}
	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
	.hove_con {
		position: relative;
		.edit_con {
			position: absolute;
			background: #FFFFFF;
			border-radius: 5px;
			box-shadow: 0 2px 4px 3px rgba(0, 0, 0, 0.2);
			padding: 0 15px;
			top: -40px;
			width: 210px;
			height: 40px;
			line-height: 40px;
			display: none;
			span {
				float: left;
				cursor: pointer;
				border-right: 1px solid #E3E3E3;
				margin: 0 8px;
			}
			span:nth-child(1) {
				padding-right: 7px;
				line-height: 25px;
				margin-top: 8px;
			}
			.icon {
				display: block;
				float: left;
				border-right: none;
				background: url(/static/image/bg03.png) no-repeat;
			}
			.icon i {
				position: absolute;
				display: block;
				font-size: 12px;
				width: auto;
				line-height: 25px;
				padding: 0px 10px;
				background: #FFFFFF;
				border-radius: 5px;
				box-shadow: 0 1px 4px 2px rgba(0, 0, 0, 0.1);
				top: -23px;
				margin-left: -25px;
				display: none;
			}
			.style {
				background-position: -60px -186px;
				width: 21px;
				height: 21px;
				margin-top: 10px;
			}
			.style:hover {
				background-position: -60px -232px;
			}
			.style:hover i {
				display: block;
			}
			.animation {
				background-position: -372px -186px;
				width: 21px;
				height: 20px;
				margin-top: 10px;
			}
			.animation:hover {
				background-position: -372px -232px;
			}
			.animation:hover i {
				display: block;
			}
			.borderhid {
				background-position: -275px -186px;
				width: 21px;
				height: 20px;
				margin-top: 10px;
			}
			.borderhid:hover {
				background-position: -275px -232px;
			}
			.borderhid:hover i {
				display: block;
			}
			.edit_Code {
				background-position: -647px -186px;
				width: 21px;
				height: 20px;
				margin-top: 10px;
			}
			.edit_Code:hover {
				background-position: -647px -232px;
			}
			.edit_Code:hover i {
				display: block;
			}
			.edit_mode {
				background-position: -420px -186px;
				width: 21px;
				height: 20px;
				margin-top: 10px;
			}
			.edit_mode:hover {
				background-position: -420px -232px;
			}
			.edit_mode:hover i {
				display: block;
			}
			.delete {
				background-position: -105px -186px;
				width: 21px;
				height: 20px;
				margin-top: 10px;
			}
			.delete:hover {
				background-position: -105px -232px;
			}
			.delete:hover i {
				display: block;
			}
		}
	}

	.hove_con:hover {
		.edit_con {
			display: block;
		}
	}

	.hove_con.hover {
		.edit_con {
			display: block;
		}
	}

	.theader {
		width: 100%;
		height: 39px;
		background-color: rgba(242, 242, 242, 1);
	}

	.tbody {
		height: 39px;
	}

	td {
		text-align: center;
		height: 60px;
	}

	button {
		width: 120px;
		height: 40px;
		display: inline-block;
		background-color: rgba(242, 242, 242, 1);
		&:last-child {
			margin-right: 0;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/t2/mConet.vue